import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import PageAuthentication from "view/Authentication/PageAuthentication";
import { getTextUrlClean } from "../../utils/Types";
import _ from "lodash";

export default function ProtectedRoute({ ...props }) {

    /*
     * =========================================================
     * LOGIN / SIGNUP
     * =========================================================
     */

    if (
        ['login', 'signup'].includes(
            props.caller
        )
    ) {

        /*
         * Usuario autenticado.
         *
         * IMPORTANTE:
         *
         * isAuth utiliza:
         *
         * -1 = comprobando
         *  0 = no autenticado
         *  1 = autenticado
         *
         * Por tanto NO debemos utilizar:
         *
         *     props.isAuth === true
         *
         * porque:
         *
         *     1 === true
         *
         * es false.
         */
        if (props.isAuth === 1) {

            const plantType = _.get(
                window,
                'renderLogic.plant_type',
                -1
            );

            const plantId = _.get(
                window,
                'renderLogic.plant_id',
                -1
            );

            const plantName = _.get(
                window,
                'renderLogic.plant_name',
                -1
            );


            /*
             * Existe un tipo de planta preferente.
             */
            if (plantType !== -1) {

                let baseUrl = 'plants/thermal';


                /*
                 * PV
                 */
                if (plantType === 0) {

                    baseUrl = 'plants/photovoltaic';


                /*
                 * ST
                 */
                } else if (
                    plantType === 1
                ) {

                    baseUrl = 'plants/thermal';


                /*
                 * TEMPERATURE
                 */
                } else if (
                    plantType === 2
                ) {

                    baseUrl = 'plants/temperature';


                /*
                 * WATER
                 */
                } else if (
                    plantType === 3
                ) {

                    baseUrl = 'plants/water';
                }


                /*
                 * Tenemos una planta concreta.
                 */
                if (
                    plantId !== -1 &&
                    plantName !== -1
                ) {

                    return (
                        <Navigate
                            to={
                                `/dashboard/${baseUrl}/${plantId}-${getTextUrlClean(plantName)}`
                            }
                            replace
                        />
                    );
                }


                /*
                 * Varias plantas del mismo tipo.
                 */
                return (
                    <Navigate
                        to={`/dashboard/${baseUrl}`}
                        replace
                    />
                );
            }


            /*
             * Si no tenemos un tipo concreto,
             * vamos al dashboard general.
             */
            return (
                <Navigate
                    to="/dashboard"
                    replace
                />
            );
        }


        /*
         * =====================================================
         * USUARIO NO AUTENTICADO
         * =====================================================
         */

        if (
            props.caller === 'login'
        ) {

            return (
                <PageAuthentication
                    path="login"
                />
            );
        }


        if (
            props.caller === 'signup'
        ) {

            return (
                <PageAuthentication
                    path="signup"
                />
            );
        }
    }


    /*
     * =========================================================
     * RUTAS PROTEGIDAS
     * =========================================================
     *
     * Si la sesión ha terminado:
     *
     *      isAuth = 0
     *
     * enviamos al login.
     */

    if (
        !['login', 'signup'].includes(
            props.caller
        ) &&
        props.isAuth === 0
    ) {

        return (
            <Navigate
                to="/login"
                replace
            />
        );
    }


    /*
     * Usuario autenticado.
     */
    return <Outlet />;
}